import asyncActionTypes from '../actions/types.js';
import FormOfPaymentCollectionUIModel from '../../api-wrapper/ui-models/form-of-payment-collection';

const initialState = {
  formOfPayments: {},
  isLoadingFormOfPayments: false,
};

const forOfPayments = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.FORM_OF_PAYMENTS.START:
      return {
        ...state,
        formOfPayments: {},
        isLoadingFormOfPayments: true,
      };
    case asyncActionTypes.FORM_OF_PAYMENTS.SUCCESS:
      if ( action.payload ) {
        return {
          ...state,
          formOfPayments: new FormOfPaymentCollectionUIModel(action.payload),
          isLoadingFormOfPayments: false,
        };
      }
      break;
    case asyncActionTypes.FORM_OF_PAYMENTS.FAIL:
      if ( action.payload ) {
        return {
          ...state,
          formOfPayments: action.payload,
          isLoadingFormOfPayments: false,
        };
      }
      break;
    default:
      return state;
  }
};

export default forOfPayments;
